import {
  buildDefaultLocalMapTranslationKey,
  IBuildType,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

const localizeShow = (
  show: Pick<IShow, "localMap"> | null | undefined,
  buildType: Pick<IBuildType, "showLocalMap"> | undefined,
  t: UseTranslateResult["t"]
) => {
  const translationKey =
    buildType?.showLocalMap?.translationKey ||
    show?.localMap?.showLocalMap?.translationKey ||
    buildDefaultLocalMapTranslationKey(ENV_KEY_PREFIX, LocalMapType.Show);

  return t(translationKey, { count: 1 });
};

export default localizeShow;
